import { Breadcrumbs, Link, Typography } from "@mui/material";
import { usePermissions } from "context/permissionContenxt";
import { Link as RouterLink } from "react-router-dom";

const ExpenseBreadcrumbs = ({ applicationId, applicationName, currentLabel }) => {
  const permissions = usePermissions();
  const expensesRootPath = permissions.can("View", "MHD_GovnrExpenses")
    ? "/govnr/expenses"
    : "/expenses";

  return (
    <Breadcrumbs
      aria-label="Διαδρομή πλοήγησης"
      sx={{ mb: 1.5, fontSize: 13 }}
    >
      <Link
        component={RouterLink}
        to={expensesRootPath}
        underline="hover"
        color="inherit"
      >
        Σύνοψη Δαπανών ΜΗΔ
      </Link>
      {currentLabel && applicationId ? (
        <Link
          component={RouterLink}
          to={`/expenses/${applicationId}`}
          underline="hover"
          color="inherit"
        >
          {applicationName || "ΜΗΔ"}
        </Link>
      ) : (
        <Typography color="text.primary" fontSize="inherit" fontWeight={600}>
          {applicationName || "ΜΗΔ"}
        </Typography>
      )}
      {currentLabel && (
        <Typography color="text.primary" fontSize="inherit" fontWeight={600}>
          {currentLabel}
        </Typography>
      )}
    </Breadcrumbs>
  );
};

export default ExpenseBreadcrumbs;
